// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Window_dialog__2ECqb","active":"Window_active__Rx3Eq"};